import {aisReserveAssetLayerSettings} from '../settings/aisReserveAssetLayerSettings';
//import {aisReserveAssetData} from './fetchMapLayers';
import {zoomToAisSite} from './aisSiteLayer';
import {aisSLayer} from './aisSiteLayer';
import {createLargeInfobox, loadMapPinHoverTooltip} from './PopupContentDialog';
import {loadMapPinAisSpeciesSelectorContent} from './PopupContentDialog';
import {loadMapPinAisContent} from './PopupContentDialog';
import {easingAnimator} from './easingAnimator';
//import {aisRALayer} from './fetchMapLayers';
import createMapMarkerHoverToolTip from './MapMarkerHoverToolTip';

export var aisRALayer = null;
export var aisReserveAssetData = [];

var xCounter=0;
function loadDataTableData(){
    xCounter++;
    if(aisReserveAssetData.length == 0 && xCounter<200){

        if ( $.fn.dataTable.isDataTable( '#aisSiteList' ) ) {
            console.log("#aisSiteList datable found");
            var table = $('#aisSiteList').DataTable( {
                retrieve: true,
                paging: false
            } );
            //console.log("table=" + table);
            //console.log("table data=" + table.data().length);
            if(table !== undefined && table != null && table.data != null && table.data() != null && table.data().length > 0){
                console.log("Assigned aisReserveAssetData");
                console.log("table data=" + table.data().length);
                aisReserveAssetData = table.data();
            }else{
                window.setTimeout(loadDataTableData,100);
            }
        }
        else {
            window.setTimeout(loadDataTableData,100);
        }

    }
}

export function loadAisReserveAssetLayer(gMap, apiLayer, guidFilter) {

    loadDataTableData();
    var deferred = new $.Deferred();
  
    var aisReserveAssetLayer = new ngislib.DynamicAGOLayer({
        url: 'https://services1.arcgis.com/RYwXzrqre8JeYrSa/ArcGIS/rest/services/Test_AIS_SpeciesDistribution_External/FeatureServer/0',
        idField: 'UniqueID',
        map: gMap,
        hasLOD: false,
        //userFilter: guidFilter,
        outFields: 'FID,UniqueID,Cent_Lat,Cent_Long'
    });
    aisReserveAssetLayer.gMap = gMap;
    aisReserveAssetLayer.LayerId = aisReserveAssetLayer.length + 1;

    aisReserveAssetLayer.minZoom = apiLayer.MinLayerVisibility;
    aisReserveAssetLayer.maxZoom = apiLayer.MaxLayerVisibility;

    aisRALayer = aisReserveAssetLayer;
    aisReserveAssetLayer.reserveAssetKeys = [];

    aisReserveAssetLayer.markers = [];
    aisReserveAssetLayer.activeMarker = null;
    aisReserveAssetLayer.clusterer =  null;

    aisReserveAssetLayer.isAddedReserveAsset = function(key) {
        var aReserveAssetKeys = this.reserveAssetKeys;
        if (aReserveAssetKeys.length == 0)
            return false;
        for (let i = 0; i < aReserveAssetKeys.length; i++) {
            var reserveAssetKey = aReserveAssetKeys[i];
            if (reserveAssetKey == key)
                return true;
        }
        return false;
    }

    aisReserveAssetLayer.reserveAssetDataLoaded = function() {
        return aisReserveAssetData.length>0;
    }

    aisReserveAssetLayer.buildMarkers = function() {
        if(this.reserveAssetDataLoaded()){            
            for(var s=0;s<aisReserveAssetData.length;s++){
                if(aisReserveAssetData[s].SensitiveSite)continue;
                var siteName = aisReserveAssetData[s].SiteName;
                var lat=aisReserveAssetData[s].CentreLat;
                var lng=aisReserveAssetData[s].CentreLng;
                var key = siteName + "|" + lat + "|" + lng;
                var assetName = aisReserveAssetData[s].AssetName;

                var exisitingMarker = this.getMarker(key);
                //if(this.isAddedReserveAsset(key)){
                if(exisitingMarker!=null){
                    if(exisitingMarker.species==1){
                        exisitingMarker.allSpecies=[];                        
                        exisitingMarker.aisReserveAssetData.isSharedSite=true;
                        exisitingMarker.allSpecies.push(exisitingMarker.aisReserveAssetData);                   
                    }
                    exisitingMarker.species++;
                    exisitingMarker.title = exisitingMarker.title + "\r\n" + assetName;
                    aisReserveAssetData[s].key=exisitingMarker.key;
                    aisReserveAssetData[s].isSharedSite=true;
                    exisitingMarker.allSpecies.push(aisReserveAssetData[s]);
                    console.log("ReserveAssetUniqueId already added "+ key)                    
                }else{
                    this.reserveAssetKeys.push(key);
                    aisReserveAssetData[s].key=key;
                    this.createAssetMarker(aisReserveAssetData[s]);                   
                }
            }

            if (this.clusterer == undefined) {
                this.clusterer = new MarkerClusterer(
                    this.gMap,
                    this.markers,
                    aisReserveAssetLayerSettings.clustererOptions
                );
              } else {
                this.clusterer.clearMarkers();
                this.clusterer.addMarkers(this.markers);
              }

            this.gMap.setInitialView();
            
        }else{
            window.setTimeout(function(){
                aisReserveAssetLayer.buildMarkers();
            },100);
        }
        
      }
      aisReserveAssetLayer.expandToFeatureZoomWait = 0;
      aisReserveAssetLayer.expandToFeature = function(marker){
        console.log("expandToFeature");
        if(typeof (marker.map) == 'undefined'){
            window.setTimeout(function(){
                aisReserveAssetLayer.expandToFeature(marker);                   
            },300);
            return;
        }
        if(marker.map == null){
            window.setTimeout(function(){
                aisReserveAssetLayer.expandToFeature(marker);                   
            },300);
            return;
        }
        var currentZoom = marker.map.getZoom();            
            console.log("zoom:" + currentZoom);
            if(currentZoom < 12) {
                zoomToAisSite(marker.siteName);
            }else{
                //console.log("less than 12");
                
                //aisReserveAssetLayer.expandToFeature(marker);
                var feature=aisSLayer.getFeatureById(marker.siteName);
                if(typeof feature == 'undefined'){
                    console.log("feature undefined");
                    window.setTimeout(function(){
                        if(aisReserveAssetLayer.expandToFeatureZoomWait==1){
                            if(currentZoom < 10)return;
                            aisReserveAssetLayer.expandToFeatureZoomWait=0;
                            marker.map.setZoom((currentZoom-1));
                        }else{
                            aisReserveAssetLayer.expandToFeatureZoomWait++;
                        }
                        aisReserveAssetLayer.expandToFeature(marker);                   
                    },300);
                    return;
                }
                console.log(typeof (feature.getGeometry));
                if(typeof (feature.getGeometry) == 'undefined'){
                    console.log("feature.getGeometry undefined");
                    window.setTimeout(function(){
                        aisReserveAssetLayer.expandToFeature(marker);                   
                    },300);
                    return;
                }
                var a = feature.getGeometry().getArray()[0].getArray();
                var featureBounds=new google.maps.LatLngBounds();
                var pointsAdded=0;
                for(var e=0;e<a.length;e++){           
                    try {
                        if(a[e].lat !== undefined){
                            pointsAdded++;
                            featureBounds.extend(a[e]);
                        }
                      } catch (error) {
                        console.error(error);
                      }
                }
                if(pointsAdded>=2){
                    var mapBounds = marker.map.getBounds();  
                    if(!mapBounds.contains(featureBounds.getNorthEast()) || !mapBounds.contains(featureBounds.getSouthWest())){
                        marker.map.fitBounds(featureBounds);
                    }
                }
            }
            var newPoint =  marker.getPosition();
            var currentPoint = marker.map.getCenter();
                easingAnimator.easeProp(marker.map,{
                    lat: currentPoint.lat(),
                    lng: currentPoint.lng()
                }, 
                {
                    lat: newPoint.lat(), 
                    lng: newPoint.lng()}
                );
            if(marker.species > 1){
                loadMapPinAisSpeciesSelectorContent(marker);
            }else{
                loadMapPinAisContent(marker, marker.aisReserveAssetData);
            }
      };
      aisReserveAssetLayer.createAssetMarker = function( aisReserveAssetData){
        var lat=aisReserveAssetData.CentreLat;
        var lng=aisReserveAssetData.CentreLng;
        var key = aisReserveAssetData.SiteName + "|" + lat + "|" + lng;
        var siteName = aisReserveAssetData.SiteName;
        var assetName = aisReserveAssetData.AssetName;
        var markerIconUrl = aisReserveAssetData.MarkerIconUrl;
        var markerActiveIconUrl = aisReserveAssetData.MarkerActiveIconUrl;
    
        // Add marker
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            title: assetName, // + " " + siteName,
            map: this.gMap,
            icon: markerIconUrl,
            //icon: image
        });
        marker.species = 1;
        marker.key = key;
        marker.markerIconUrl = markerIconUrl;
        marker.markerActiveIconUrl = markerActiveIconUrl;
        marker.siteName = siteName;
        marker.reserveAssetUniqueId = aisReserveAssetData.ReserveAssetUniqueId;
        marker.aisReserveAssetData=aisReserveAssetData;
        marker.layer=aisReserveAssetLayer;
        marker.markerPos = this.markers.length+1;
        this.markers.push(marker);
        this.gMap.markers.push(marker); // Also add to gMap markers so initial view can be setup
        marker.addListener('click', () => {
            
            aisReserveAssetLayer.clearActiveFeature();
            aisReserveAssetLayer.activeMarker = marker;
            marker.setIcon(marker.markerActiveIconUrl);
            var feature=aisReserveAssetLayer.getFeatureById(aisReserveAssetData.ReserveAssetUniqueId);
            if(feature!=null){
                aisReserveAssetLayer.overrideStyle(
                    feature,
                    aisReserveAssetLayerSettings.inactiveAisReserveAsset.styles.selected
                );
            }
            aisReserveAssetLayer.expandToFeatureZoomWait=0;
            aisReserveAssetLayer.expandToFeature(marker);
            /*var currentZoom = marker.map.getZoom();            
            if(currentZoom < 12) {
                zoomToAisSite(marker.siteName);
            }else{
                //console.log("less than 12");
                aisReserveAssetLayer.expandToFeature(marker);
                var feature=aisSLayer.getFeatureById(marker.siteName);
                var a = feature.getGeometry().getArray()[0].getArray();
                var featureBounds=new google.maps.LatLngBounds();
                var pointsAdded=0;
                for(var e=0;e<a.length;e++){           
                    try {
                        if(a[e].lat !== undefined){
                            pointsAdded++;
                            featureBounds.extend(a[e]);
                        }
                      } catch (error) {
                        console.error(error);
                      }
                }
                if(pointsAdded>=2){
                    var mapBounds = marker.map.getBounds();  
                    if(!mapBounds.contains(featureBounds.getNorthEast()) || !mapBounds.contains(featureBounds.getSouthWest())){
                        marker.map.fitBounds(featureBounds);
                    }
                }
            }
            var newPoint =  marker.getPosition();
            var currentPoint = marker.map.getCenter();
                easingAnimator.easeProp(marker.map,{
                    lat: currentPoint.lat(),
                    lng: currentPoint.lng()
                }, 
                {
                    lat: newPoint.lat(), 
                    lng: newPoint.lng()}
                );
            if(marker.species > 1){
                loadMapPinAisSpeciesSelectorContent(marker);
                console.log(marker);
            }else{
                loadMapPinAisContent(marker, marker.aisReserveAssetData);
            }*/
            

        });
        // Due to multiple species the event need to added here
        // to receive all the data
        let hoverTooltip;
        marker.addListener('mouseover', () => {
            marker.setTitle(null);
            hoverTooltip = loadMapPinHoverTooltip(marker, google);
            hoverTooltip.setMap(this.gMap);
        });

        marker.addListener('mouseout', () => {
            hoverTooltip.setMap(null);
        });
    }

    aisReserveAssetLayer.setStyle(aisReserveAssetLayerSettings.inactiveAisReserveAsset.styles.defaultState);
    aisReserveAssetLayer.getMarker=function (key) {
      var markers = this.markers;
      if (markers.length == 0)
          return null;
      for (let i = 0; i < markers.length; i++) {
          var marker = markers[i];
          if (key == marker.key) {
              return marker;
          }
      }
      return null;
    }

    aisReserveAssetLayer.clearActiveFeature=function(){
        if(aisReserveAssetLayer.activeMarker!=null){
            aisReserveAssetLayer.activeMarker.setIcon(aisReserveAssetLayer.activeMarker.markerIconUrl);
            var activeFeatureId = aisReserveAssetLayer.activeMarker.reserveAssetUniqueId;
            var activeFeature=aisReserveAssetLayer.getFeatureById(activeFeatureId);
            if(activeFeature!=null){
                aisReserveAssetLayer.overrideStyle(
                    activeFeature,
                    aisReserveAssetLayerSettings.inactiveAisReserveAsset.styles.defaultState
                );
            }
            aisReserveAssetLayer.activeMarker=null;
        }       
    }
    aisReserveAssetLayer.updateFeatureStyles=function(){
        if(aisReserveAssetLayer.activeMarker!=null){
            var activeFeatureId = aisReserveAssetLayer.activeMarker.reserveAssetUniqueId;
            var activeFeature=aisReserveAssetLayer.getFeatureById(activeFeatureId);
            if(activeFeature!=null){
                aisReserveAssetLayer.overrideStyle(
                    activeFeature,
                    aisReserveAssetLayerSettings.inactiveAisReserveAsset.styles.selected
                );
            }
        }
    }

    aisReserveAssetLayer.getAisReserveAssetData=function(aisReserveAssetId){
        for(var s=0;s<aisReserveAssetData.length;s++){
            if(aisReserveAssetData[s].ReserveAssetUniqueId==aisReserveAssetId){
                return aisReserveAssetData[s];                
            }
        }
        return null;
    }

    aisReserveAssetLayer.buildMarkers();
 
    /* *** Add layer listeners *** */
    google.maps.event.addListener(aisReserveAssetLayer, 'click', function (event) {
        var feat = event.feature;
        var map = aisReserveAssetLayer.map;
        var featId = false;
        
        console.log("Click aisReserveAssetLayer layer ");

        if (typeof feat !== 'undefined' && feat !== null) {
            featId = feat.getId();
        }
  
        if (featId) {
            var aisReserveAssetId = feat.getId();
            var aisReserveAssetInfo=false;
            aisReserveAssetInfo=this.getAisReserveAssetData(aisReserveAssetId);
            if(aisReserveAssetInfo){
                aisReserveAssetLayer.ZoomFeature(feat);                
            }
        }
  
    });
  
    google.maps.event.addListener(
        aisReserveAssetLayer,
        'status_changed',
        function (e) {
        //when aisReserveAssetLayer is panned, the aisReserveAssetLayer  is refreshed, so does the data
        //so every feature that has been set is reset to initial state
        aisReserveAssetLayer.updateFeatureStyles();
    });

    google.maps.event.addListener(
        aisReserveAssetLayer,
        'mouseover',
        function (event) {
            return;
            var feat = event.feature;
            var map = aisReserveAssetLayer.map;
            var featId = false;
            
            console.log("Click aisReserveAssetLayer layer ");
            if (typeof feat !== 'undefined' && feat !== null) {
                featId = feat.getId();
            }
      
            if (featId) {
                var aisReserveAssetId = feat.getId();
                var aisReserveAssetInfo=false;
                aisReserveAssetInfo=this.getAisReserveAssetData(aisReserveAssetId);
                if(aisReserveAssetInfo){
                    aisReserveAssetLayer.overrideStyle(
                        feat,
                        aisReserveAssetLayerSettings.inactiveAisReserveAsset.styles.hover
                      );
                }
            }
        }
    );
    google.maps.event.addListener(
        aisReserveAssetLayer,
        'mouseout',
        function (event) {
            return;
            var feat = event.feature;
            var map = aisReserveAssetLayer.map;
            var featId = false;
            
            console.log("Click aisReserveAssetLayer layer ");
            if (typeof feat !== 'undefined' && feat !== null) {
                featId = feat.getId();
            }
      
            if (featId) {
                var aisReserveAssetId = feat.getId();
                var aisReserveAssetInfo=false;
                aisReserveAssetInfo=this.getAisReserveAssetData(aisReserveAssetId);
                /*for(var s=0;s<aisReserveAssetData.length;s++){
                    if(aisReserveAssetData[s].ReserveAssetUniqueId==aisReserveAssetId){
                        aisReserveAssetInfo = aisReserveAssetData[s];
                        break;
                    }
                }*/
                if(aisReserveAssetInfo){
                    //alert("found " + aisReserveAssetId);
                    //aisReserveAssetLayer.ZoomFeature(feat);
                    aisReserveAssetLayer.overrideStyle(
                        feat,
                        aisReserveAssetLayerSettings.inactiveAisReserveAsset.styles.defaultState
                      );
                }
            }
        }
    );
  
    /* *** End add layer listeners *** */
  
    /* *** Add map listeners *** */
  
    google.maps.event.addListener(aisReserveAssetLayer.map, 'zoom_changed',
        function (e) {
        var zoomLevel = this.getZoom();
        var map = this;
        var isVisible = (aisReserveAssetLayer.minZoom <= zoomLevel) && (zoomLevel <= aisReserveAssetLayer.maxZoom);
  
        aisReserveAssetLayer.SetVisible(isVisible);
    });
  
    /* *** End add map listeners *** */
  
    //return deferred.promise();
    deferred.promise();
    return aisReserveAssetLayer;
  }
  
  export function showSpeciesInfo(key, reserveAssetUniqueId){
    if(aisRALayer !== undefined && aisRALayer != null){
        var marker = aisRALayer.getMarker(key);
        if(marker != null){
            if(reserveAssetUniqueId==""){
                loadMapPinAisSpeciesSelectorContent(marker);
            }else{
                var aisReserveAssetInfo=aisRALayer.getAisReserveAssetData(reserveAssetUniqueId);
                loadMapPinAisContent(marker, aisReserveAssetInfo)
            }
        }else{
            console.log("marker not found");
        }
    }
    
}

export function activatePin(key){
    if(aisRALayer !== undefined && aisRALayer != null){
        for(var s=0;s<aisReserveAssetData.length;s++){
            if(aisReserveAssetData[s].SensitiveSite)continue;

            if(aisReserveAssetData[s].ReserveAssetId == key){
                aisRALayer.gMap.setCenter(new google.maps.LatLng(aisReserveAssetData[s].CentreLat, aisReserveAssetData[s].CentreLng));
                aisRALayer.gMap.setZoom(12);
                const element = document.getElementsByClassName("npws-customMap-gmap");
                //element[0].scrollIntoView(true);
                element[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                /*window.setTimeout(function(){
                    zoomToAisSite(aisReserveAssetData[s].SiteName);                    
                },1000);                        
                window.setTimeout(function(){
                    var marker = aisRALayer.getMarker(aisReserveAssetData[s].key);
                    new google.maps.event.trigger( marker, 'click' );
                },1500);*/
                var marker = aisRALayer.getMarker(aisReserveAssetData[s].key);
                    new google.maps.event.trigger( marker, 'click' );
                break;
            }                        
        }
    }
    
}
   
